<template>
    <div
        :class="action === '1' ? ['fixedLeftPerson', 'fixedLeftDiv'] : ['tourist-service']"
        @click="openChatDialog"
    >
        <template v-if="action === '1'">
            <img :src="require('@/assets/homeImages/message.png')">
            <p class="fixedLeftP">{{ $t('Online Service') }}</p>
        </template>
        <!-- 登录页在线客服入口 -->
        <template v-else>
            <i class="iconfont iconzaixiankefu" />
            <span class="text">{{ $t('Online Service') }}</span>
        </template>

    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        action: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapState('chat', [ 'touristService' ]),
        ...mapState({
            customerServiceInfo: state => state.timStore.customerServiceInfo,
            currentUserProfile: state => state.timStore.currentUserProfile,
            conversationList: state => state.timStore.conversationList
        }),
        ...mapGetters([ 'isLogin', 'settingConfig' ]),
        ...mapGetters([ 'ident', 'isLogin', 'locale', 'config', 'isTIM' ])
    },
    mounted() {
        // this.getInfo()
    },

    methods: {
        // 打开聊天框
        async openChatDialog() {
            console.log('(this.$store.getters.isLogin--->', this.$store.getters.isLogin)
            //     // 接收在线客服
        }
    }
}
</script>

<style lang="stylus">
.tourist-service {
    cursor: pointer;
    .iconzaixiankefu {
        color: $color-main;
        margin: 0;
        vertical-align: middle;
    }
    .text {
        margin-top: -2px;

        &:hover {
            color: $color-main;
        }
    }
}
</style>
